import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=61b6f82e&scoped=true&lang=pug"
import script from "./SignForm.vue?vue&type=script&lang=js"
export * from "./SignForm.vue?vue&type=script&lang=js"
import style0 from "./SignForm.vue?vue&type=style&index=0&id=61b6f82e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6f82e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b6f82e')) {
      api.createRecord('61b6f82e', component.options)
    } else {
      api.reload('61b6f82e', component.options)
    }
    module.hot.accept("./SignForm.vue?vue&type=template&id=61b6f82e&scoped=true&lang=pug", function () {
      api.rerender('61b6f82e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/newYear2024/components/SignForm.vue"
export default component.exports